module.exports = __webpack_public_path__ + "static/img/icon_weixin.3429ac76.png";